import styled, { css } from 'styled-components/macro';
import { ControlWrapper } from '../controls.styled';

const sizeMap = {
  s: { width: 30, height: 16, thumb: 12, offset: 2 },
  m: { width: 44, height: 24, thumb: 20, offset: 2 },
};

export const StyledSwitch = styled(ControlWrapper)`
  ${({ theme, $size }) => {
    const { width, height, thumb, offset } = sizeMap[$size];
    const translateX = width - thumb - offset * 2;

    return css`
      min-width: ${width}px;
      min-height: ${height}px;
      max-width: ${width}px;
      max-height: ${height}px;
      border-radius: ${height / 2}px;
      background-color: ${theme.semantic.control.track};
      overflow: hidden;

      &::after {
        content: '';
        position: absolute;
        bottom: ${offset}px;
        left: ${offset}px;
        width: ${thumb}px;
        height: ${thumb}px;
        border-radius: 50%;
        background-color: ${theme.semantic.switch.thumb};
        transform: translateX(0);
        transition-property: transform, width;
        transition-duration: ${theme.tokens.animation.duration.base};
        transition-timing-function: ${theme.tokens.animation.easing.elastic};
        pointer-events: none;
      }

      &:has(input:checked) {
        background-color: ${theme.semantic.control.bgChecked};

        &::after {
          transform: translateX(${translateX}px);
        }
      }

      &:not(:has(input:disabled)):hover {
        background-color: ${theme.semantic.control.trackHover};
      }

      &:has(input:checked):not(:has(input:disabled)):hover {
        background-color: ${theme.semantic.control.bgCheckedHover};
      }

      &:not(:has(input:disabled)):active::after {
        width: ${thumb + 4}px;
        transform: translateX(0);
      }

      &:has(input:checked):not(:has(input:disabled)):active::after {
        width: ${thumb + 4}px;
        transform: translateX(${translateX - 4}px);
      }

      &:has(input:disabled) {
        background-color: ${theme.semantic.switch.trackDisabled};

        &::after {
          background-color: ${theme.semantic.switch.thumbDisabled};
          box-shadow: none;
        }
      }
    `;
  }}
`;
